var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgClock(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 13,
    viewBox: "0 0 12 13",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.9974 0.414062C5.23135 0.414062 4.47281 0.564946 3.76508 0.858099C3.05734 1.15125 2.41428 1.58093 1.87261 2.12261C0.778644 3.21657 0.164063 4.7003 0.164062 6.2474C0.164063 7.79449 0.778644 9.27822 1.87261 10.3722C2.41428 10.9139 3.05734 11.3435 3.76508 11.6367C4.47281 11.9298 5.23135 12.0807 5.9974 12.0807C7.54449 12.0807 9.02822 11.4661 10.1222 10.3722C11.2161 9.27822 11.8307 7.79449 11.8307 6.2474C11.8307 5.48135 11.6798 4.72281 11.3867 4.01508C11.0935 3.30734 10.6639 2.66428 10.1222 2.12261C9.58051 1.58093 8.93745 1.15125 8.22972 0.858099C7.52198 0.564946 6.76344 0.414063 5.9974 0.414062ZM8.4474 8.6974L5.41406 6.83073V3.33073H6.28906V6.36406L8.91406 7.93906L8.4474 8.6974Z",
    fill: "black",
    fillOpacity: 0.4
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgClock);
export default __webpack_public_path__ + "static/media/clock.cef96164ebd5c5a6e9a967fe6fc6ee67.svg";
export { ForwardRef as ReactComponent };